import { useState, useEffect, useCallback } from 'react';
import { getCompanyAiFeatures, updateCompanyAiFeature } from './api';

// The "AI" card on /companies (ADR-033). One fetch returns every AI-group
// feature with licensed / cap / this-month usage; `update` patches one feature
// ({ enabled } | { monthly_call_cap }) and reloads. Mirrors useCompanyAccess.
export default function useCompanyAiFeatures({ companyId }) {
    const [features, setFeatures] = useState([]);
    const [otherUsage, setOtherUsage] = useState(null);
    const [totals, setTotals] = useState({ month_cost_usd: 0 });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(null); // feature key being saved

    const load = useCallback(async () => {
        if (!companyId) { setFeatures([]); setOtherUsage(null); return; }
        setLoading(true);
        try {
            const res = await getCompanyAiFeatures(companyId);
            const d = (res && res.data) || {};
            setFeatures(d.features || []);
            setOtherUsage(d.other_usage || null);
            setTotals(d.totals || { month_cost_usd: 0 });
        } catch {
            setFeatures([]); setOtherUsage(null);
        } finally {
            setLoading(false);
        }
    }, [companyId]);
    useEffect(() => { load(); }, [load]);

    const update = useCallback(async (featureKey, patch) => {
        if (!companyId) return;
        setSaving(featureKey);
        try {
            await updateCompanyAiFeature(companyId, featureKey, patch);
            await load();
        } finally {
            setSaving(null);
        }
    }, [companyId, load]);

    return {
        features, otherUsage, totals, loading, saving, update, refetch: load,
    };
}
